import { queryOptions } from "@tanstack/react-query";
import * as v from "valibot";

import { leakedCodeReader } from "./_runtime";
import { LeakedCodeReader } from "./leakedCodeReader/service";

export const LeakedCodesCounts = v.object({
  active: v.number(),
  couponExtension: v.number(),
  highRisk: v.number(),
  inactive: v.number(),
});
export type LeakedCodesCounts = v.InferOutput<typeof LeakedCodesCounts>;

const fetchLeakedCodesCounts =
  ({ leakedCodeReader }: { leakedCodeReader: LeakedCodeReader }) =>
  async () => {
    const leakedCodesCounts = await leakedCodeReader.counts();

    return v.parse(LeakedCodesCounts, {
      ...leakedCodesCounts,
    });
  };

export const LeakedCodeCountsQuery = () =>
  queryOptions({
    queryFn: () => fetchLeakedCodesCounts({ leakedCodeReader })(),
    queryKey: ["leakedCodeCounts"],
  });
